import React from 'react'
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import { 
    GuestListTableContainer, 
} from './guests.style';

import {
    TableHead,
    TableBodyRow
} from './../../../../widget/styledComponents/table.style'
import Cookies from 'js-cookie';
import { gql,useQuery } from '@apollo/client';
import { Pagination, Spinner } from 'evergreen-ui'
import { formatDate } from '../../../../widget/util';



export const FETCH_GUEST_LIST = gql`
query Visitations_getByFacility($facilityId: ID!, $pagination: PaginationInput!) {
  visitations_getByFacility(facilityId: $facilityId, pagination: $pagination) {
    _id
    resident
    createdBy
    facility
    guestName
    guestPhone
    guestType
    status
    entryCode
    startDate
    endDate
    entryDate
    createdAt
    id
  }
}
`;

function GuestPageWidget() {
    
const facilityName = Cookies.get('facilityName');
const facilityId = Cookies.get('facilityId');

const { loading, data }  = useQuery(FETCH_GUEST_LIST,{
    variables: {
        facilityId:facilityId,
        pagination: {
            "cursor": null,
            "limit": 30
        },
     },
    });
  return (
    <div className=''>
         <br/><br/>
        <div className='row'>
            <div className='col s12 m3'>
                <PageTitleText>
                    Guest -{facilityName}
                </PageTitleText>
            </div>
            
        </div>  
        
        <GuestListTableContainer>
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>Guests</TableHead>
                    <TableHead>phone</TableHead>
                    <TableHead>Guest type</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead>Entry date</TableHead>
                </tr>
                </thead>

                <tbody>
                    {loading && <Spinner/> }
                    {data &&
                    
                    data.visitations_getByFacility.map((data) => 
                        <TableBodyRow>
                            <td>{data.guestName}</td>
                            <td>{data.guestPhone}</td>
                            <td>{data.guestType}</td>
                            <td>{data.status}</td>
                            <td>{data.entryDate ===undefined ||
                                data.entryDate ===null
                                ? '---'
                                :formatDate(data.entryDate)??'---'
                                // :data.entryDate.toString()
                            }</td>
                            <td>
                                <i className='material-icons' style={{
                                    color:"#A1A1AA"
                                }}>more_horiz</i>
                            </td>
                        </TableBodyRow>
                        )
                    }
                   
                </tbody>
            </table>
            <Pagination className='transparent z-depth-0' page={1} totalPages={3}></Pagination>
        </GuestListTableContainer>
    </div>
  )
}

export default GuestPageWidget